import { Getter } from 'vuex'
import { UserState } from '../types'
import { RootState } from '@/store/types'

const getUserDisabledTextNotifications: Getter<UserState, RootState> = (
  state
) => {
  return state.disableTextNotifications
}

export default getUserDisabledTextNotifications
